import useApiCall from './apiCall';
import store from '../store';

export default function useNotifications() {
  const { getData, postData, postMultipartData, putMultipartData, getDataSilent, deleteData } = useApiCall();

  async function getNotifications({ skip = 0, take = 10, userId = null, orderBy = null, searchQuery = null } = {}) {
    const params = new URLSearchParams();
    params.append('skip', skip);
    params.append('take', take);
    if (userId) params.append('userId', userId);
    if (orderBy) params.append('orderBy', orderBy);
    if (searchQuery) params.append('searchQuery', searchQuery);
    return await getData('notifications', { params });
  }

  async function getCompactUsers({ searchQuery = null, role = 'patient', skip = 0, take = 20 } = {}) {
    const params = new URLSearchParams();
    params.append('skip', skip);
    params.append('take', take);
    if (searchQuery) params.append('searchQuery', searchQuery);
    if (role) params.append('role', role);
    return await getData('users/compact', { params });
  }

  async function getCustomQueries({ skip = 0, take = 50, scope = 'notificationRecipients' } = {}) {
    const params = new URLSearchParams();
    params.append('skip', skip);
    params.append('take', take);
    if (scope) params.append('scope', scope);
    return await getData('custom-queries', { params });
  }

  async function prepareNotification(notification, recipientsExcel) {
    const formData = new FormData();
    formData.append('request', JSON.stringify({ notification }));
    if (recipientsExcel) formData.append('recipientsExcel', recipientsExcel);

    const response = await postMultipartData('prepared-notifications', formData);
    if (response) {
      store.commit('setFormMessages', {
        type: 'success',
        texts: ['Notifikace byla připravena k odeslání'],
      });
    }
    return response;
  }

  async function getPreparedNotifications({ skip = 0, take = 10, status = 'prepared' } = {}) {
    const params = new URLSearchParams();
    params.append('skip', skip);
    params.append('take', take);
    if (status) params.append('status', status);
    return await getData('prepared-notifications', { params });
  }

  async function sendPreparedNotification(id) {
    const response = await postData(`prepared-notifications/${id}/push`, null);
    if (response !== undefined) {
      store.commit('setFormMessages', {
        type: 'success',
        texts: ['Notifikace byla úspěšně odeslána'],
      });
    }
    return response;
  }

  async function updatePreparedNotification(id, notification, recipientsExcel) {
    const formData = new FormData();
    formData.append('request', JSON.stringify({ notification }));
    if (recipientsExcel) formData.append('recipientsExcel', recipientsExcel);
    const response = await putMultipartData(`prepared-notifications/${id}`, formData);
    if (response) {
      store.commit('setFormMessages', { type: 'success', texts: ['Notifikace byla aktualizována'] });
    }
    return response;
  }

  async function getPreparedNotificationRecipients(id, { skip = 0, take = 10, searchQuery = null } = {}) {
    const params = new URLSearchParams();
    params.append('skip', skip);
    params.append('take', take);
    if (searchQuery) params.append('searchQuery', searchQuery);
    return await getData(`prepared-notifications/${id}/recipients`, { params });
  }

  async function getPushStatus(operationId) {
    return await getDataSilent(`prepared-notifications/push-status/${operationId}`);
  }

  async function deletePreparedNotification(id) {
    const response = await deleteData(`prepared-notifications/${id}`);
    if (response !== undefined) {
      store.commit('setFormMessages', {
        type: 'success',
        texts: ['Notifikace byla smazána'],
      });
    }
    return response;
  }

  return {
    getNotifications,
    getCompactUsers,
    getCustomQueries,
    prepareNotification,
    updatePreparedNotification,
    getPreparedNotifications,
    getPreparedNotificationRecipients,
    getPushStatus,
    sendPreparedNotification,
    deletePreparedNotification,
  };
}
